export default {
  prospectClient: {
    list: [],
    total: 0
  },

  crrProspectClient: {}
}
